/* global ResizeObserver, HTMLElement, customElements */

class QuicklinksElement extends HTMLElement {
  constructor () {
    super()

    this.$clone = document.createElement('div')
    this.$clone.innerHTML = this.innerHTML
    this.$clone.classList.add('quicklinks', 'quicklinks--clone')
    this.$clone.setAttribute('aria-hidden', true)
    this.$clone.inert = true

    this.observer = new ResizeObserver((entries) => {
      this.ownerDocument.body.appendChild(this.$clone)
      const cloneWidth = this.$clone.getBoundingClientRect().width
      this.$clone.remove()

      for (const entry of entries) {
        this.classList.toggle('is-collapsed', entry.borderBoxSize[0].inlineSize < cloneWidth)
      }
    })
  }

  connectedCallback () {
    this.observer.observe(this)
  }

  disconnectedCallback () {
    this.observer.unobserve(this)
  }
}

customElements.define('x-quicklinks', QuicklinksElement)
